<template>
  <div
    v-if="visible"
    class="large-amount-overlay"
    @click.self="cancel"
    @keydown.esc.stop="cancel"
  >
    <div class="large-amount-window" role="dialog" aria-modal="true">
      <p class="large-amount-title">Uwaga, duża suma!</p>
      <p class="large-amount-text">
        Upewnij się, że podana kwota jest prawidłowa. Wpisz poniżej kwotę
        doładowania, aby potwierdzić
      </p>
      <form @submit.prevent="confirm">
        <input
          ref="amountInput"
          type="text"
          inputmode="decimal"
          autocomplete="off"
          class="form-control"
          v-model="enteredAmount"
          placeholder="Wpisz kwotę"
        />
        <p class="large-amount-error" v-if="error">{{ error }}</p>
        <div class="large-amount-buttons">
          <custom-button
            :gray="true"
            title="Anuluj"
            :size="'small'"
            @click="cancel"
            :customStyles="'text-transform: uppercase; width: 200px; height: 30px;'"
          />
          <custom-button
            :gradient="true"
            title="Potwierdź"
            :size="'small'"
            @click="confirm"
            :customStyles="'text-transform: uppercase; width: 200px; height: 30px;'"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CustomButton from "./CustomButton.vue";
import { amountsMatch } from "../utils/largeAmount";

export default {
  name: "LargeAmountConfirm",
  components: { CustomButton },
  props: {
    visible: { type: Boolean, default: false },
    amount: { type: [Number, String], default: null },
  },
  emits: ["confirmed", "cancel"],
  data() {
    return {
      enteredAmount: "",
      error: "",
    };
  },
  watch: {
    visible(isVisible) {
      this.enteredAmount = "";
      this.error = "";
      if (isVisible) {
        this.$nextTick(() => this.$refs.amountInput?.focus());
      }
    },
    enteredAmount() {
      this.error = "";
    },
  },
  methods: {
    confirm() {
      if (!amountsMatch(this.enteredAmount, this.amount)) {
        this.error = "Wpisana kwota nie zgadza się z podaną kwotą";
        return;
      }
      this.$emit("confirmed");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
/* Fixed overlay above the Bootstrap modal (z-index 1050) instead of a second stacked modal. */
.large-amount-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(9, 7, 65, 0.5);
}
.large-amount-window {
  width: 480px;
  max-width: calc(100% - 32px);
  padding: 24px !important;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  font-size: 14px;
}
.large-amount-title {
  font-size: 18px;
  font-weight: 600;
  color: #ff1a1a;
  margin-bottom: 8px;
}
.large-amount-text {
  margin-bottom: 16px;
}
.large-amount-error {
  margin-top: 8px;
  margin-bottom: 0;
  color: #ff1a1a;
}
.large-amount-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
}
</style>
